import { Button, Stack, Typography } from '@mui/material';
import { ReactFlowProvider } from '@xyflow/react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '@xyflow/react/dist/style.css';
import { ScenarioDiagramContext } from '../../../state/Context';
import UnitDialog from '../diagrams/UnitDialog';
import ScenarioFlow from '../diagrams/ScenarioFlow';
import { Toolbar } from '../../common';

import HeaderCard from './HeaderCard';

function UnitsStep({ onBack, onNext }) {
  const { t } = useTranslation();

  const [state, setState] = useState({ open: false, data: {} });
  const memoizedState = useMemo(() => ({ state, setState }), [state]);

  return (
    <Stack spacing={2} sx={{ height: '100%' }}>
      <HeaderCard title={t('pages.scenarios.configure.units.title')}>
        <Typography>
          {t('pages.scenarios.configure.units.subheader')}
        </Typography>
      </HeaderCard>
      <ScenarioDiagramContext.Provider value={memoizedState}>
        <ReactFlowProvider>
          <ScenarioFlow />
        </ReactFlowProvider>
        <UnitDialog />
      </ScenarioDiagramContext.Provider>
      <Toolbar>
        <Button onClick={onBack}>{t('common.back')}</Button>
        <Button onClick={onNext}>{t('common.next')}</Button>
      </Toolbar>
    </Stack>
  );
}

export default UnitsStep;
